import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import {
  ButtonAnalize,
  ButtonDownloadPgn,
  ButtonDraw,
  ButtonLeave,
  ButtonResign,
  ButtonRotate,
} from '@features/game/ui/GameButtons/GameButtons';
import { components } from '@features/shared/api/game';

import styles from './GameActions.module.css';

export function GameActions({
  isRotated,
  system,
  isPlaying,
  canRequestDraw,
  canResign,
  canAnalyze,
  canDownloadPgn,
  video,
  onRotate,
  onDraw,
  onResign,
  onDownload,
  onLeave,
  onAnalize,
}: {
  isRotated?: boolean | null;
  system?: components['schemas']['TournamentSystem'];
  isPlaying?: boolean;
  canRequestDraw?: boolean;
  canResign?: boolean;
  canAnalyze?: boolean;
  canDownloadPgn?: boolean;
  // кнопка видеоконтроля: только в турнирах с видео
  video?: ReactNode;
  onRotate?: () => void;
  onDraw?: () => void;
  onResign?: () => void;
  onDownload?: () => void;
  onLeave?: () => void;
  onAnalize?: () => void;
}) {
  // Кнопка поворота: только там, где нет кнопки на самой доске (мобилка)
  const btnRotate = onRotate && (
    <ButtonRotate onClick={onRotate}>
      {isRotated && isPlaying ? 'Обратно' : 'Развернуть'}
    </ButtonRotate>
  );

  return isPlaying ? (
    <div className={cx(styles.actions, styles.is_playing)}>
      {btnRotate}
      {video}
      <ButtonDraw disabled={!canRequestDraw} onClick={onDraw} />
      <ButtonResign disabled={!canResign} onClick={onResign} />
    </div>
  ) : (
    <div className={cx(styles.actions, styles.is_watching)}>
      {btnRotate}
      {video}
      {(canAnalyze || canDownloadPgn) && (
        <div className={styles.double}>
          <ButtonAnalize disabled={!canAnalyze} onClick={onAnalize}>
            Анализ
          </ButtonAnalize>
          <ButtonDownloadPgn disabled={!canDownloadPgn} onClick={onDownload}>
            Скачать
          </ButtonDownloadPgn>
        </div>
      )}
      <ButtonLeave system={system} onClick={onLeave} />
    </div>
  );
}
